import PrivateParentChildren from './PrivateParentChildren';

export default PrivateParentChildren;
